import { createRouter, createWebHistory } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login/LoginPage.vue'
import Reset from '../views/Login/PassReset.vue'

import guidesCreate from '../views/Guide/guidesCreate.vue'
import Settings from '../views/Settings.vue'


const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    meta: { title: 'Дашборд' }
  },
  {
    path: '/login',
    component: Login,
    meta: { title: 'Вход в систему' }
  },
  {
    path: '/login/reset',
    component: Reset,
    meta: { title: 'Сброс пароля' }
  },
  {
    path: '/guides',
    children: [
      {
        path: '',
        name: 'Guides',
        component: () => import('../views/Guide/guidesList.vue'),
        meta: { title: 'Справочники' }
      },
      {
        path: 'create',
        component: guidesCreate,
        meta: { title: 'Создание справочника' }
      },
      {
        path: 'autos',
        component: () => import('../views/Guide/guidesAutosView.vue'),
      },
      {
        path: 'agents',
        component: () => import('../views/Guide/guidesAgentsView.vue'),
      },
      {
        path: ':id/create',
        component: () => import('../views/Guide/guidesViewCreate.vue'),
      },
    ]
  },
  {
    path: '/analytics',
    children: [
      {
        path: '',
        name: 'Analytics',
        component: () => import('../views/Analytics/reportsList.vue'),
        meta: { title: 'Аналитика' }
      },
      {
        path: 'create',
        component: () => import('../views/Analytics/reportsCreate.vue'),
        meta: { title: 'Создание отчета' }
      },
      {
        path: '1',
        component: () => import('../views/Analytics/reportsView1.vue'),
      },
      {
        path: '2',
        component: () => import('../views/Analytics/reportsView2.vue'),
      },
      {
        path: '3',
        component: () => import('../views/Analytics/reportsView3.vue'),
      },
      {
        path: '4',
        component: () => import('../views/Analytics/reportsView4.vue'),
      },
      {
        path: '5',
        component: () => import('../views/Analytics/reportsView5.vue'),
      },
      {
        path: '6',
        component: () => import('../views/Analytics/reportsView6.vue'),
      },
      {
        path: '7',
        component: () => import('../views/Analytics/reportsView7Stop.vue'),
      }
    ]
  },
  {
    path: '/reports',
    children: [
      {
        path: '',
        component: () => import('../views/Reports/ReportsMain.vue'),
        meta: { title: 'Отчеты' }
      },
      {
        path: 'protection',
        children: [

          {
            path: ':id',
            component: () => import('../views/Reports/LaborProtection/View/protectionView.vue'),
          },
          {
            path: ':id/create',
            component: () => import('../views/Reports/LaborProtection/Create/protectionItemCreate.vue'),
          },
          {
            path: ':id/report/:id',
            component: () => import('../views/Reports/LaborProtection/View/protectionItemView.vue'),
          }
        ]
      },
      {
        path: 'appeal',
        children: [

          {
            path: ':id',
            component: () => import('../views/Reports/Appeal/View/AppealView.vue'),
          },
          {
            path: ':id/report/:id',
            component: () => import('../views/Reports/Appeal/View/AppealItemView.vue'),
          }
        ]
      }
    ]
  },
  {
    path: '/algorithms',
    children: [
      {
        path: '',
        name: 'Algorithms',
        component: () => import('../views/Algorithms/algorithmsList.vue'),
      },
      {
        path: 'create',
        name: 'AlgorithmsCreate',
        component: () => import('../views/Algorithms/algorithmsCreate.vue'),
      },
    ]
  },
  {
    path: '/addresses',
    children: [
      {
        path: '',
        name: 'Addresses',
        component: () => import('../views/Algorithms/addressesList.vue'),
        meta: { title: 'Адреса' }
      },
      {
        path: 'create',
        name: 'AddressesCreate',
        component: () => import('../views/Algorithms/addressesCreate.vue'),
        meta: { title: 'Создать' }
      },
    ]
  },
  {
    path: '/sources',
    children: [
      {
        path: '',
        name: 'Sources',
        component: () => import('../views/Algorithms/sourcesList.vue'),
      },
      {
        path: 'create',
        name: 'SourcesCreate',
        component: () => import('../views/Algorithms/sourcesCreate.vue'),
      },
    ]
  },
  {
    path: '/users',
    children: [
      {
        path: '',
        name: 'Users',
        component: () => import('../views/Users/usersList.vue'),
      },
      {
        path: 'create',
        component: () => import('../views/Users/usersCreate.vue'),
      },
      {
        path: ':id/edit',
        component: () => import('../views/Users/usersEdit.vue'),
      },
      // {
      //   path: ':id/change_password',
      //   component: () => import('../views/Users/usersPassEdit.vue'),
      // }
]
},
{
  path: '/polygon',
      children: [
  {
    path: 'inn',
    name: 'Company',
    component: () => import('../views/Polygon/Inn.vue'),
    meta: { title: 'ИНН' }
  },
  {
    path: '/edit-car/:id',
    name: 'EditCar',
    component: () => import('../views/Polygon/EditWasteCar.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: 'profile',
    name: 'Users',
    component: () => import('../views/Polygon/Profile.vue'),
    meta: { title: 'Профиль' }
  },
  {
    path: 'history',
    name: 'history',
    component: () => import('../views/Polygon/History.vue'),
    meta: { title: 'История рейсов' }
  },
  {
    path: 'contracts',
    component: () => import('../views/Polygon/Contracts.vue'),
    meta: { title: 'Список договоров' }
  },
  {
    path: 'new_order',
    name: 'new_order',
    component: () => import('../views/Polygon/NewOrder.vue'),
    props: true,
    meta: { title: 'Новая заявка' }
  },
  {
    path: 'edit_order',
    name: 'edit_order',
    component: () => import('../views/Polygon/EditOrder.vue'),
    props: true,
    meta: { title: 'Редактирование заявки' }
  },
  {
    path: 'cars',
    component: () => import('../views/Polygon/Cars.vue'),
    meta: { title: 'Автомобили' }
  },
  {
    path: 'new_waste_car',
    component: () => import('../views/Polygon/NewWasteCar.vue'),
  },
  {
    path: 'all-contracts',
    component: () => import('../views/Polygon/AllContracts.vue'),
  },
]
},
{
  path: '/ecology',
      children: [
  {
    path: 'partners',
    component: () => import('../views/Ecology/Partners.vue'),
  },
  {
    path: 'contracts',
    component: () => import('../views/Ecology/Contracts.vue'),
  },
  {
    path: 'waste_reports',
    component: () => import('../views/Ecology/WasteReports.vue'),
  },
  {
    path: '/partner_waste_reports/:id',
    name: 'partner_waste_reports',
    component: () => import('../views/Ecology/PartnerWasteReports.vue'),
  }
]
},
{
  path: '/settings',
      name: 'Settings',
    component: Settings
},
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach((to, from, next) => {
  const publicPages = ['/login', '/login/reset', '/register', '/home'];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('user');

  // Устанавливаем заголовок
  const defaultTitle = 'Дашборд';
  document.title = to.meta?.title || defaultTitle;

  if (authRequired && !loggedIn) {
    next('/login');
  } else {
    next();
  }
});

export default router
